<div *ngIf="device.id && hasBattviewFautlsData" class="panel-body boxs3">
	<app-grid-v2 id="Fault" [columns]="gridColumns" [data]="gridData"></app-grid-v2>
</div>
<div *ngIf="!hasBattviewFautlsData">
	<div class="panel panel-default">
		<div class="panel-body">
			<strong>No Battview Faults Found!</strong>
		</div>
	</div>
</div>